
	import {
		Component,
		Vue
	} from "vue-property-decorator";
	import PageFooter from '@/components/page-footer.vue';
	import {
		getProviderProductEarnings
	} from '@/api/supplier'

	@Component({
		name: 'data-detail',
		components: {
			PageFooter
		}
	})
	export default class DataDetail extends Vue {
		private id = +this.$route.query.id;
		private start = this.$route.query.start;
		private end = this.$route.query.end;
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;

		mounted() {
			this.getList();
		}

		// 获取列表
		private async getList() {
			try {
				const res: any = await getProviderProductEarnings({
					ProviderId: this.id,
					StartTime: this.start,
					EndTime: this.end,
					Skip: (this.pageNo-1)*this.pageSize,
					Take: this.pageSize,
				})
				this.list = res.Result.Results;
				this.total = res.Result.Total;
			} catch (err) {
				console.log(err)
			}
		}

		private pageChange(num: number) {
			this.pageNo = num;
			this.getList();
		}
	}
